import { IOption } from '../interfaces';

import { catalogoLenguage } from './dictionaries';

export const getAvailableItems = ({
  initialList,
  isStateOrCity = false,
}: {
  initialList: {
    externalCode: string;
    label_es_ES: string;
    status?: string;
  }[];
  isStateOrCity?: boolean;
}) => {
  let availableItems = initialList?.filter((item) => !!item?.label_es_ES);

  if (isStateOrCity) {
    availableItems = availableItems?.filter((item) => item?.status === catalogoLenguage.status);
  }

  return availableItems;
};

export const formatCountrySelect = ({
  initialList,
  isStateOrCity = false,
}: {
  initialList: {
    externalCode: string;
    label_es_ES: string;
    status?: string;
  }[];
  isStateOrCity?: boolean;
}) => {
  const availableItems = getAvailableItems({ initialList, isStateOrCity });

  availableItems?.sort((a, b) => a.label_es_ES.localeCompare(b.label_es_ES));

  return (availableItems?.map((item) => ({
    value: item.label_es_ES,
    label: item.label_es_ES,
  })) ?? [{ label: 'cargando', value: 'cargando' }]) as IOption[];
};
